import React from "react";

import AppModal from "../AppModal";
import { i18n } from "../../translate/i18n";

function ConfirmationModal({
	title, children, open, onClose, onConfirm,
}) {
	return (
		<AppModal
			open={open}
			onClose={() => onClose(false)}
			title={title}
			maxWidth={480}
			footer={
				<>
					<button
						type="button"
						className="btn btn-sub-gray"
						onClick={() => onClose(false)}
					>
						{i18n.t("confirmationModal.buttons.cancel")}
					</button>
					<button
						type="button"
						className="btn btn-primary"
						onClick={() => {
							onClose(false);
							onConfirm();
						}}
					>
						{i18n.t("confirmationModal.buttons.confirm")}
					</button>
				</>
			}
		>
			<p className="m-0 text-sm leading-6 text-default-700 dark:text-default-200">
				{children}
			</p>
		</AppModal>
	);
}

export default ConfirmationModal;
